import { translations } from "./en_EN";

export const t = (key: string) => {
    return translations[key] || key;
}